// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__27Fht","alertIcon":"ConfirmModal_alertIcon__K3-cv"};